<template>
  <div class="l-contentmain contentmai">
    <div class="has-background-white">
      <form id="form-user">
        <div class="is-padding">
          <div class="columns">
            <div class="column">
              <h2 class="title is-2 has-text-weight-black">
                Informations utilisateur
              </h2>
            </div>
          </div>
          <div class="columns">
            <div class="column is-6">
              <v-input
                id="password1"
                name="password"
                :input-type="displayClearPassword ? 'text' : 'password'"
                @input="val => password = val"
                :model="password"
                autocomplete="current-password"
                label="Mot de passe actuel *"
                v-validate="'required|min:8'"
                :errors-bag="errors"
                data-vv-value-path="val"
                data-vv-as="Mot de passe">
                <r-label
                  slot="label"
                  :is-required="true"
                  :label="'Mot de passe actuel'"
                  :value="password"></r-label>
              </v-input>
            </div>
          </div>
          <div class="columns">
            <div class="column">
              <v-input
                id="newPassword1"
                name="newPassword"
                :input-type="displayClearPassword ? 'text' : 'password'"
                @input="val => newPassword = val"
                :model="newPassword"
                autocomplete="new-password"
                :errors-bag="errors"
                data-vv-value-path="val"
                data-vv-as="Mot de passe">
                <r-label
                  slot="label"
                  :is-required="true"
                  :label="'Nouveau mot de passe'"
                  :value="newPassword"></r-label>
              </v-input>
            </div>
            <div class="column">
              <v-input
                id="password2"
                name="confirmPassword"
                :input-type="displayClearPassword ? 'text' : 'password'"
                @input="val => confirmPassword = val"
                :model="confirmPassword"
                autocomplete="current-password"
                label=" *"
                :errors-bag="errors"
                data-vv-value-path="val"
                data-vv-as="Confirmation du mot de passe">
                <r-label
                  slot="label"
                  :is-required="true"
                  :label="'Confirmation du nouveau mot de passe'"
                  :value="confirmPassword"></r-label>
              </v-input>
            </div>
          </div>
          <div class="is-flex is-align-items-center is-margin-top-small">
            <a
              class="is-flex is-align-items-center"
              @click="displayClearPassword = !displayClearPassword"
              style="cursor: pointer;">
              <i
                class="is-margin-right-xsmall fal fa-eye"
                :class="displayClearPassword ? 'fa-eye-slash' : 'fa-eye'"></i>
              <span>{{ !displayClearPassword ? 'Afficher' : 'Cacher' }} les mots de passe</span>
            </a>
            <div class="is-margin-left-large">
              <password-validator
                :password="newPassword"
                :text-size="'1.2rem'"
                :confirm-password="confirmPassword"
                :min-length="12"
                :require-lower-case="true"
                :show-confirmation="true"
                @validation-changed="passwordIsValid = $event">
              </password-validator>
            </div>
          </div>
        </div>
        <submit-sticky-buttons
          @submit="submitNewPassword"
          :loading="submitLoading"
          button-id="changePasswordForm"></submit-sticky-buttons>
      </form>
    </div>
  </div>
</template>

<script>
import { User } from '@/mixins'

export default {
  name: 'ChangePassword',
  mixins: [User],
  computed: {
    canSubmit () {
      return this.samePassword && this.password
    }
  }
}
</script>
